const clean = value => String(value ?? '').trim().toLowerCase()
const digits = value => String(value ?? '').replace(/\D/g, '')

export function reviewLegacyServices(rows, customers, records) {
  return rows.map(row => {
    const person = row.normalised.customer
    const service = row.normalised.service
    const contact = (customers || []).filter(customer =>
      (person.email && clean(customer.email) === clean(person.email))
      || (person.phone && digits(customer.phone) && digits(customer.phone) === digits(person.phone)))
    const reference = row.normalised.source_reference
    const sourceMatch = reference && (records || []).find(record =>
      clean(record.source_system) === clean(row.normalised.source_system)
      && clean(record.source_reference) === clean(reference))
    const errors = [...row.errors]
    if (!person.first_name || !person.last_name || (!person.email && !person.phone)) {
      errors.push('A real customer name and contact are required for service history.')
    }
    if (person.phone && (digits(person.phone).length < 7 || digits(person.phone).length > 16)) {
      errors.push('Service-history contact number is invalid.')
    }
    if (person.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(person.email)) {
      errors.push('Service-history email is invalid.')
    }
    if (!service.service_title && !service.service_description) errors.push('Actual performed service facts are required.')
    if (contact.length > 1 || contact.some(customer =>
      clean(customer.first_name) !== clean(person.first_name) || clean(customer.last_name) !== clean(person.last_name))) {
      errors.push('Customer contact identity is ambiguous; resolve this row before import.')
    }
    const currentFacts = legacyServicePayload([row])[0]
    const sameFacts = sourceMatch?.raw_data && Object.keys(currentFacts).filter(key => key !== 'row_number')
      .every(key => JSON.stringify(sourceMatch.raw_data[key] ?? '') === JSON.stringify(currentFacts[key] ?? ''))
    if (sourceMatch && (sourceMatch.customer_id !== contact[0]?.id
      || (sourceMatch.raw_data ? !sameFacts : sourceMatch.service_title !== service.service_title
        || sourceMatch.service_description !== service.service_description))) {
      errors.push('Source reference conflicts with existing service history.')
    }
    return { ...row, errors, matchedCustomer: contact[0] || null, sourceMatch }
  })
}

export function legacyServicePayload(rows) {
  return rows.map(row => ({
    row_number: row.rowNumber,
    source_system: row.normalised.source_system,
    source_reference: row.normalised.source_reference,
    customer_first_name: row.normalised.customer.first_name,
    customer_last_name: row.normalised.customer.last_name,
    customer_email: row.normalised.customer.email,
    customer_phone: row.normalised.customer.phone,
    customer_notes: row.normalised.customer.notes,
    service_date: row.normalised.service.service_date_text,
    service_title: row.normalised.service.service_title,
    service_description: row.normalised.service.service_description,
    amount_charged: row.normalised.service.amount_charged,
    currency: row.raw.currency || '',
    service_notes: row.normalised.service.notes,
    setup_text: row.normalised.service.setup_text,
    bike_facts: row.normalised.bike,
    component_facts: row.normalised.component,
  }))
}
